import { FC, useRef, useState } from 'react';
import { Select } from 'antd';
import classnames from 'classnames';
import { isIOS, isMobileOnly } from 'react-device-detect';

import { Option } from 'models/form';

import { EmptyComponent } from 'componets/ui';

import { ReactComponent as Arrow } from 'assets/icons/arrow-select.svg';

import styles from './index.module.scss';
import './index.scss';

type SelectFieldProps = {
	options: Option[];
	placeholder: string;
	onChange?: (v: string) => void;
	value?: string;
	id?: string;
	selectText?: string;
	isFilter?: boolean;
	disabled?: boolean;
};

export const SelectField: FC<SelectFieldProps> = ({
	options,
	placeholder,
	onChange,
	value,
	id,
	selectText,
	isFilter,
	disabled
}) => {
	const [focus, setFocus] = useState(false);

	const ref = useRef(null);

	return (
		<div className={styles.root}>
			{isMobileOnly ? (
				<select
					disabled={disabled}
					id={id}
					className={classnames('mobileSelect', { mobileSelect__opacity: !value && isIOS })}
					value={value || ''}
					onChange={(e) => {
						if (onChange) {
							onChange(e.target.value);
						}
					}}
					onBlur={() => {
						setFocus(false);
					}}
					onFocus={() => setFocus(true)}
					onTouchStart={() => setFocus(true)}
				>
					{!value && (
						<option value="" hidden disabled>
							{isIOS && selectText}
						</option>
					)}
					{options.map((option) => (
						<option value={option.value} key={option.value}>
							{option.label}
						</option>
					))}
				</select>
			) : (
				<Select
					disabled={disabled}
					id={id}
					notFoundContent={<EmptyComponent />}
					ref={ref}
					showSearch={isFilter}
					virtual={false}
					suffixIcon={<Arrow />}
					onChange={onChange}
					value={value}
					onBlur={() => setFocus(false)}
					onFocus={() => {
						setFocus(true);
					}}
					getPopupContainer={(trigger) => trigger.parentNode || document.body}
					filterOption={(input, option) => {
						const boolArray = Object.entries(option || {}).map(([, value]) => {
							return (
								typeof value === 'string' && value.toLowerCase().indexOf(input.toLowerCase()) >= 0
							);
						});
						return boolArray.indexOf(true) > -1;
					}}
					optionFilterProp="label"
				>
					{options.map((option) => (
						<Select.Option value={option.value} key={option.value}>
							{option.label}
						</Select.Option>
					))}
				</Select>
			)}

			{isMobileOnly && <Arrow className="mobileSelect__arrow" />}
			<label
				className={classnames('float-label', styles.label, {
					[styles.focused]: focus || (value && value.length !== 0),
					'focused-float-label': focus,
				})}
			>
				{placeholder}
			</label>
		</div>
	);
};
